(function() {
	'use strict';

	angular
		.module('pwc.controllers')
		.controller('DebugController', DebugController);

	DebugController.$inject = ['userPouch', 'systemPouch', '$log', 'lodash', 'BUILD_NUMBER'];

	function DebugController(userPouch, systemPouch, $log, lodash, BUILD_NUMBER) {

		/* jshint validthis: true */
		var self = this;

		self.users = [];

		self.build = BUILD_NUMBER;

		self.adapter = {
			users: null,
			wines: null,
			system: null
		};

		self.wipe = wipe;

		initialize();

		/** begin methods */

		function initialize(){

            userPouch.allUsers().then(function(response){
				$log.debug('Users', response);

				if (response.rows){
					self.users = lodash.pluck(response.rows, 'doc');
				}
				return true;
			});

			self.adapter.users = userPouch.localUserDatabase().adapter;
			self.adapter.wines = userPouch.db().adapter;
			self.adapter.system = systemPouch.db().adapter;
		}
	}

})();
